export const PROJECT_GRADIENTS = {
  "gradient-1": "from-primary to-secondary-dark",
  "gradient-2": "from-secondary-dark to-primary",
  "gradient-3": "from-darkgrey to-primary",
  "gradient-4": "from-secondary to-secondary-dark",
  "gradient-5": "from-primary to-darkgrey",
  "gradient-6": "from-mediumgrey to-darkgrey",
  "gradient-7": "from-secondary to-primary",
};

export const PROJECT_GRADIENT_OPTIONS = [
  { id: "gradient-1", name: "Navy → Sky" },
  { id: "gradient-2", name: "Sky → Navy" },
  { id: "gradient-3", name: "Slate → Navy" },
  { id: "gradient-4", name: "Sky → Ocean" },
  { id: "gradient-5", name: "Navy → Slate" },
  { id: "gradient-6", name: "Silver → Slate" },
  { id: "gradient-7", name: "Secondary → Primary" },
];
